import {FieldValidations} from '@/types/document-viewer/field/modules/validation'
import {countDecimals} from '@/utils'
import moment from 'moment/moment'

export const checkIsValidFormField = (
    {key, params, value}: { key: FieldValidations, params: any, value: any }
): boolean => {
    if (!key) {
        return true
    }
    if (key === FieldValidations.REQUIRED) {
        return typeof value === 'number' || (!!value && String(value).trim() !== '')
    } else if (key === FieldValidations.ROUNDING) {
        return !!value && !!params && countDecimals(value) === params.value
    } else if (key === FieldValidations.MIN_LENGTH) {
        return !!value && !!params && value.length >= params.value
    } else if (key === FieldValidations.MAX_LENGTH) {
        return !!value && !!params && value.length <= params.value
    } else if (key === FieldValidations.EMAIL) {
        return !!value && /\S+@\S+\.\S+/.test(String(value).trim())
    } else if (key === FieldValidations.NUMBER) {
        return !isNaN(parseFloat(value)) && isFinite(value)
    } else if (key === FieldValidations.DATE) {
        return !!params && moment(value, params.format, true).isValid()
    }
    return true
}
